// エージェントの使い方（サンプルプロンプト）モーダル。
//
// 役割: AI に何を頼めるかを、src/agent/skills/ の各スキルに対応したサンプルプロンプト集として提示する。
//       サンプルをクリックすると onPick で本文を親（ChatPanel）へ返し、入力欄へ挿入できる。
// 関係: 既存の .modal-overlay / .modal を流用。ChatPanel が helpOpen のとき描画し、onClose で閉じる。
//       カテゴリは spatial-functions / viz / geoboundaries / data-join / spatial-core に対応。

// サンプルプロンプト集（カテゴリ別）。文言は実レイヤー名に依存しない一般形にしている。
const SAMPLE_GROUPS = [
  {
    title: 'バッファ（緩衝域）',
    prompts: ['駅レイヤーから半径 5km のバッファを作って', '道路から 100m 以内の範囲を面にして'],
  },
  {
    title: '簡略化',
    prompts: ['市区町村レイヤーを 100m で簡略化して', '海岸線レイヤーを形を保ったまま粗くして'],
  },
  {
    title: 'ディゾルブ（境界融合）',
    prompts: ['市区町村レイヤーを都道府県でディゾルブして', '同じ用途区分のポリゴンを 1 つにまとめて'],
  },
  {
    title: '空間結合・抽出',
    prompts: [
      '駅レイヤーから 500m 以内にある建物を抽出して',
      '市区町村ポリゴンごとに含まれる施設の数を数えて',
    ],
  },
  {
    title: '計測・面積',
    prompts: ['各ポリゴンの面積を m² で計算して列に追加して', '各ラインの長さを m で計算して'],
  },
  {
    title: 'コロプレス（属性値で塗り分け）',
    prompts: ['人口の列でレイヤーを塗り分けて', '人口密度で 5 段階に塗り分けて凡例を出して'],
  },
  {
    title: '行政界データの取得',
    prompts: ['geoBoundariesから日本の都道府県境界を取得して', 'フランスの国境を取得して'],
  },
  {
    title: 'データテーブルとの結合',
    prompts: ['市区町村ポリゴンにアップした人口 CSV を code で結合して'],
  },
]

function AgentHelpModal({ onClose, onPick }) {
  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="modal modal-wide help-modal" onClick={(e) => e.stopPropagation()}>
        <h3>使い方 — サンプルプロンプト</h3>

        <p className="help-lead">
          自然言語で指示すると、AI エージェントが空間処理を実行し、結果を新しいレイヤーとして地図に追加します。
          下のサンプルをクリックすると入力欄に挿入されます（レイヤー名や数値は対象に合わせて書き換えてください）。
        </p>

        <div className="help-groups">
          {SAMPLE_GROUPS.map((group) => (
            <section className="help-group" key={group.title}>
              <h4>{group.title}</h4>
              <ul className="help-prompt-list">
                {group.prompts.map((prompt) => (
                  <li key={prompt}>
                    <button type="button" className="help-prompt" onClick={() => onPick(prompt)}>
                      {prompt}
                    </button>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>

        <div className="modal-actions">
          <button onClick={onClose}>閉じる</button>
        </div>
      </div>
    </div>
  )
}

export default AgentHelpModal
